import { LOCALES } from 'state/intl/types';
import logger from 'utils/logger';

const localeImport = {
  en_us: () => import(`@formatjs/intl-listformat/locale-data/en-US`),
};

export const polyfillListFormatLocale = async (locale: LOCALES) => {
  try {
    if (locale in LOCALES) {
      await localeImport[locale]();
    } else {
      await import('@formatjs/intl-listformat/locale-data/en-US');
    }
  } catch (e) {
    logger.warn(e);
  }
};
